import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PayloadBuilder from './PayloadBuilder';
import DocumentGenerator from './DocumentGenerator';
import PackingList from './components/PackingList';
import { DUMMY_PACKING_DATA } from './data/dummyData';
import './styles.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main route - Payload Builder */}
        <Route path="/" element={<PayloadBuilder />} />
        
        {/* Legacy document generator route */}
        <Route path="/generator" element={<DocumentGenerator />} />
        
        {/* Document display route (used by iframe) */}
        <Route path="/document" element={
          <div className="App">
            <button className="print-button no-print" onClick={() => window.print()}>
              Print Packing List
            </button>
            <PackingList data={DUMMY_PACKING_DATA} />
          </div>
        } />
        
        {/* API static document route will be handled by Vercel function */}
      </Routes>
    </Router>
  );
}

export default App;